import { BasicResult } from "../basic-result";
import { AuditLocation } from "./audit-location";

export class AuditLocationResult extends BasicResult {
    public Locations: AuditLocation[] = [];
    constructor(values: Object = {}) {
        super()
        Object.assign(this, values);
        if (values.hasOwnProperty('Locations')) {
            this.Locations = [];
            ((values as AuditLocationResult)['Locations'] as AuditLocation[]).forEach(element => {
                this.Locations.push(new AuditLocation(element));
            });
        }
    }
}